import React from "react"
import plateStyles from './plate_styles.module.scss'

import missingFill from '../../../../assets/blank-grey.png'

const CoachPlate = ({ coachName, index, imageUrl}) => {

    // parse name //
    const coachNameArray = coachName.split(' ')
    const firstName = coachNameArray[0]
    const lastName = coachNameArray.slice(1, coachNameArray.length).join(' ')

    return (
        <div className={plateStyles.playerPlateContainer}>
            <div className={plateStyles.playerPlateIndex}>
                {index + 1 }
            </div>
            <div className={plateStyles.iconContainer}>
                <img
                    className={plateStyles.coachIcon}
                    src={imageUrl === '' ? missingFill : imageUrl}
                    alt={`${lastName}, ${firstName}`}
                />
            </div>
            <div className={plateStyles.metaContainer}>
                <div className={plateStyles.coachNameContainer}>
                    <p className={plateStyles.firstName}>
                        {firstName}
                    </p>
                    <p className={plateStyles.lastName}>
                        {lastName}
                    </p>
                </div>
            </div>
        </div>
    )
    
}

export default CoachPlate




